import { SET_COUNT } from './constants';

export function setCount(namespace: string, count: string) {
    return {
        type: SET_COUNT,
        payload: {
            namespace,
            count
        }
    };
}
